import { commonValidators } from "helper/customHook";

const field = {
  monthSelected: "monthSelected",
};

export const schemasFormImport = {
  [field.monthSelected]: [commonValidators.required],
};
